export const GET_DISABILITIES = 'SENIOR_CITIZEN_SETTINGS/get_disabilities';
export const SHOW_DISABILITY = 'SENIOR_CITIZEN_SETTINGS/show_disability';
export const CREATE_DISABILITY = 'SENIOR_CITIZEN_SETTINGS/create_disability';
export const UPDATE_DISABILITY = 'SENIOR_CITIZEN_SETTINGS/update_disability';
export const REMOVE_DISABILITY = 'SENIOR_CITIZEN_SETTINGS/remove_disability';

export const FORM_DATA = {
  name: '',
};
